export type Mark = "x" | "o" | null;

export type Board = Mark[];

export const LINES: number[][] = [
	[0, 1, 2],
	[3, 4, 5],
	[6, 7, 8],
	[0, 3, 6],
	[1, 4, 7],
	[2, 5, 8],
	[0, 4, 8],
	[2, 4, 6],
];

export const createBoard = (): Board => Array.from({ length: 9 }, () => null);

export const findWinningLine = (board: Board): number[] | null => {
	for (const line of LINES) {
		const [a, b, c] = line as [number, number, number];
		if (board[a] && board[a] === board[b] && board[a] === board[c]) return line;
	}
	return null;
};

export const isBoardFull = (board: Board): boolean => board.every((cell) => cell !== null);

const findCompletingCell = (board: Board, mark: Exclude<Mark, null>): number | null => {
	for (const line of LINES) {
		const [a, b, c] = line as [number, number, number];
		const cells = [a, b, c];
		const owned = cells.filter((index) => board[index] === mark).length;
		const empty = cells.filter((index) => board[index] === null);
		if (owned === 2 && empty.length === 1) return empty[0] as number;
	}
	return null;
};

const pick = (candidates: number[], board: Board, seed: number): number | null => {
	const free = candidates.filter((index) => board[index] === null);
	if (!free.length) return null;
	return free[seed % free.length] as number;
};

export const pickKioskMove = (board: Board, seed: number): number | null => {
	const win = findCompletingCell(board, "o");
	if (win !== null) return win;

	const block = findCompletingCell(board, "x");
	if (block !== null) return block;

	if (board[4] === null) return 4;

	return pick([0, 2, 6, 8], board, seed) ?? pick([1, 3, 5, 7], board, seed);
};
